// src/components/CustomerFlow/Steps/FinalStep.js

import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const FinalStep = ({ onComplete }) => {
  const hasCompleted = useRef(false);

  useEffect(() => {
    if (!hasCompleted.current) {
      cleanupStorage();
      hasCompleted.current = true;
    }
  }, []);

  /**
   * Limpia todos los datos del storage relacionados con el token temporal y el flujo
   * Usa prefijo temp_ para no afectar la sesión del vendedor si está usando la misma ventana
   */
  const cleanupStorage = () => {
    // Limpiar tokens y datos del flujo
    localStorage.removeItem('temp_authToken');
    localStorage.removeItem('temp_tokenScope');
    localStorage.removeItem('temp_tokenType');
    localStorage.removeItem('temp_tokenSaleId');
    localStorage.removeItem('temp_tokenCustomerId');
    localStorage.removeItem('temp_tokenPurchaseRequestId');
    localStorage.removeItem('temp_tokenBranchId');
    localStorage.removeItem('temp_tokenDni');
    localStorage.removeItem('temp_tokenLastValidation');
    
    // Limpiar datos de la tarjeta
    localStorage.removeItem('temp_card_last_four');
    localStorage.removeItem('temp_card_brand_name');
  };

  return (
    <div className="final-step bg-white p-4 rounded-3 text-center">
      <div className="mb-4">
        <FontAwesomeIcon icon={faCheck} className="text-success" style={{ fontSize: '4rem' }} />
      </div>
      <h3 className="text-success mb-3">¡Listo! Tu compra está confirmada</h3>
      <p className="text-muted">
      Quedó todo procesado. Si necesitás algo más, hablá con el vendedor del comercio.
      </p>
      <p className="text-muted">
        Ya podés cerrar esta página.
      </p>
    </div>
  );
};

export default FinalStep;
